
const tourSteps = [
  {
    selector: '.saras-tour-search-results-filter-view',
    content: 'Select the View option to switch between pre-filtered templates of the search results.',
  },
  {
    selector: '.saras-tour-search-results-filter-general',
    content: 'Use the filter option to narrow down your search results based on specific criteria.',
  },
  {
    selector: '.saras-tour-search-results-filter-date',
    content: 'Click on date filter to quickly filter results by date range.',
  },
  {
    selector: '.saras-tour-search-results-filter-favorite',
    content: 'Add current filter as a favorite or select a favorite filter to apply it to the search results.',
  },
  {
    selector: '.saras-tour-search-results-filter-sort',
    content: 'Use the sort option to arrange your search results based on specific criteria.',
  },
  {
    selector: '.saras-tour-search-results-filter-group',
    content: 'Group your search results on a specific column to easily analyze large data.',
  },
  {
    selector: '.saras-tour-search-results-filter-summary',
    content: 'View a summary of your search results, including key metrics and insights.',
  },
  {
    selector: '.saras-tour-search-results-filter-reload',
    content: 'Reload the search results to get the most up-to-date information.',
  },
  {
    selector: '.saras-tour-search-results-filter-paging',
    content: 'Use the paging option to navigate through different pages of search results.',
  },
  {
    selector: '.saras-tour-search-results-header',
    content: 'Access shortcut filter by clicking on the header or select one or more rows if applicable.',
  },
  {
    selector: '.saras-tour-search-results-actions',
    content: 'These are actions you can perform on the search results. You can select multiple records and select an action to perform.',
  },
  {
    selector: '.saras-tour-search-results-default-actions',
    content: 'Access default actions like Create New, Quick Create',
  },
  // Add more steps as needed
];

export default tourSteps;
